<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom affiché" matTooltipPosition="right"></fa-icon>
            </div>

            @if (_context.mode !== FormMode.Creation) {
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Ordre</mat-label>
                        <input matInput data-input-order type="number" formControlName="order" autocomplete="off" />
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Ordre d'affichage" matTooltipPosition="right"></fa-icon>
                </div>
            }

            @if (!!groups) {
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Groupe</mat-label>
                        <mat-select data-select-groupId formControlName="groupId" required>
                            @for (group of groups; track group) {
                                <mat-option data-select-listing-type-option [value]="group.id">
                                    {{ group.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (formGroupErrors?.groupId?.required && (formGroup.controls['groupId']?.dirty || formGroup.controls['groupId'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Groupe' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Groupe dans lequel la bannette sera affiché" matTooltipPosition="right"></fa-icon>
                </div>
            }
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
